<template>
  <div class="input-group">
    <label class="input-group-text" for="selectChallenge">challenge</label>
    <select
      id="selectChallenge"
      class="form-select"
      v-model="selectedChallenge"
      @change="challengeChanged"
    >
      <option
        v-for="challenge of challengeData"
        :key="challenge.id"
        :value="challenge.id"
      >
        {{ challenge.name }}
      </option>
    </select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'challenge-lookup',
  emits: ['changed'],
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('reporting', ['analysis']),
    ...mapGetters('challenges', ['challenges']),
    challengeData() {
      let _data = []
      _data.push({
        id: null,
        name: '',
      })
      if (this.challenges) {
        this.challenges.forEach((element) => {
          _data.push({
            id: element.id,
            name: element.name,
          })
        })
      }
      return _data
    },
    selectedChallenge: {
      get() {
        let _data = null
        if (this.analysis) {
          _data = this.analysis.challengeId
        }
        return _data
      },
      set(value) {
        this.setAnalysisData({
          name: 'challengeId',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('reporting', ['setAnalysisData']),
    ...mapActions('challenges', ['getChallengeList']),
    async loadChallenges(orgId) {
      await this.getChallengeList({
        orgId: orgId,
      })
    },
    challengeChanged() {
      this.$emit('changed')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-action-button:focus {
  box-shadow: none !important;
}
.custom-reload {
  font-size: 1.2em;
  top: 1px;
  position: relative;
}
</style>
